import {
  getEquipmentLineList,
  productionLineTemplate,
  importProductLines,
} from "@ckweb/ckfetch/connectables/equipmentAreaManagement";

const FETCH_ID = "ProductionLines";

export const useGetProductionLinesTemplate = () =>
  useSafeLocalFetch(`fetch${FETCH_ID}Template`, productionLineTemplate, {
    fetchType: "download",
    showGlobalLoadingIndicator: true,
  });

export const useGetProductionLines = () =>
  useSafeLocalFetch(`fetch${FETCH_ID}`, getEquipmentLineList, {
    fallback: [],
  });

export const useSubmitProductionLines = () =>
  useSafeLocalFetch(`import${FETCH_ID}`, importProductLines, {
    fetchType: "mutate",
    showGlobalLoadingIndicator: true,
    enableGlobalNotifications: true,
  });
